import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import WebsiteContent from './WebsiteContent';
import { restrictUrls } from '../../../helpers/adminPrivileges';

function action({ store }) {
  const title = 'Website Content';

  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  const adminPrivileges = store.getState().account && store.getState().account.privileges;
  const privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

  if (!isAdminAuthenticated) return { redirect: '/login' };

  // Ikut hak akses "Manage Homepage Settings" (privilege id 2) — halaman ini
  // menggantikan enam tab Home Page Settings, jadi tidak ada gunanya membuat
  // hak akses baru yang harus diberikan ulang ke setiap peran.
  if (!restrictUrls('/siteadmin/website-content', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: (
      <AdminLayout>
        <WebsiteContent />
      </AdminLayout>
    )
  };
}

export default action;
